import React, { Component } from 'react'
import '../styles/OtherProjectList.css'
import BeneficiaryOrganizations from './BeneficiaryOrganizations'
import BeneficiaryFarmers from './BeneficiaryFarmers'

class OtherProjectDetails extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			listItems: [],
			items: [],
			itemObj: {},
			keyTracer: 0,
			disabled: props.disabled,
			isViewDetails: props.isViewDetails,
			pid: props.pid
		}
		this.onSubmit = this.onSubmit.bind(this)
		this.setContent = this.setContent.bind(this)
	}

	onSubmit() {
	}

	componentDidMount() {
		this.setContent(sessionStorage.getItem("projects-tabId"))
	}

	setContent(id) {
		let content
		switch(id) {
			case "pdh-farmer":
				content = <BeneficiaryFarmers isViewDetails={this.state.isViewDetails}
					pid={this.state.pid} displayValues={!this.state.disabled} projectName={this.props.projectName} />
				break
			default:
				content = <BeneficiaryOrganizations isViewDetails={this.state.isViewDetails}
					pid={this.state.pid} displayValues={!this.state.disabled} submit={() => {
						this.setState({disabled: false})
					}}  projectName={this.props.projectName} />
		}
		this.setState({content: content})
	}

	render() {
		const view = <div id="other-project-details">
			<Header onItemClick={(item) => {
				this.setContent(item)
				sessionStorage.setItem("projects-tabId", item)
			}} disabled={this.state.disabled} />
			<Body content={this.state.content} />
		</div>
		return(view)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {disabled: props.disabled}
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
	}

	componentDidMount() {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#project-details-header > div')
		for(const f of items) {
			f.style.color = "#646464"
		}
		const imgs = document.querySelectorAll('#project-details-header > div > img')
		for(const f of imgs) {
			f.style.opacity = "1.0"
		}
		const tabId = sessionStorage.getItem("projects-tabId")
		switch(tabId) {
			case "pdh-farmer":
				var elem = document.getElementById(tabId)
				elem.style.background = "#e2e2e2"
				break
			default:
				elem = document.getElementById("pdh-org")
				elem.style.background = "#e2e2e2"
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.disabled != prevProps.disabled) {
			this.setState({disabled: this.props.disabled})
			if(this.props.disabled) {
				return
			}
			const items = document.querySelectorAll('#project-details-header > div')
			for(const f of items) {
				f.style.color = "#646464"
			}
			const imgs = document.querySelectorAll('#project-details-header > div > img')
			for(const f of imgs) {
				f.style.opacity = "1.0"
			}
		}
	}

	onItemClick(e) {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#project-details-header > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.props.onItemClick(e.target.id)
	}

	mouseEnter(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	render() {
		const view = <div id="project-details-header">
			<div id="pdh-org" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>BENEFICIARY ORGANIZATIONS</div>
			<div id="pdh-farmer" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}>BENEFICIARY FARMERS</div>
		</div>
		return(view)
	}
}

class Body extends Component
{
	render() {
		const view = <div id="project-details-body">
			<div id="pdb-content">
				{this.props.content}
			</div>
			<div id="pdb-content-hl-top"></div>
		</div>
		return(view)
	}
}

export default OtherProjectDetails
